import { createContext as createContext$1, useContext } from "react";
import { j as assign, P as PURPLE_THEME } from "./purpleTheme-CUaQ2Ptp.mjs";
import { css as css$1, StyleSheetManager, ThemeProvider } from "styled-components";
import { j as jsxRuntimeExports } from "./jsx-runtime-ClFauRgV.mjs";
import { k as kindredShouldForwardProp } from "./shouldForwardProp-BVWMire5.mjs";
function createContext(options) {
  const {
    name,
    defaultValue,
    hookName,
    providerName
  } = options;
  const Context = createContext$1(defaultValue);
  Context.displayName = name;
  const useContext$1 = () => {
    const context = useContext(Context);
    if (!context) {
      throw new Error(`${hookName} must be used inside of a ${providerName}`);
    }
    return context;
  };
  return [Context.Provider, useContext$1, Context];
}
var merge = function merge2(a, b) {
  var result = assign({}, a, b);
  for (var key in a) {
    var _assign;
    if (!a[key] || typeof b[key] !== "object") continue;
    assign(result, (_assign = {}, _assign[key] = assign(a[key], b[key]), _assign));
  }
  return result;
};
var sort = function sort2(obj) {
  var next = {};
  Object.keys(obj).sort(function(a, b) {
    return a.localeCompare(b, void 0, {
      numeric: true,
      sensitivity: "base"
    });
  }).forEach(function(key) {
    next[key] = obj[key];
  });
  return next;
};
var defaults$4 = {
  breakpoints: [40, 52, 64].map(function(n) {
    return n + "em";
  })
};
var createMediaQuery = function createMediaQuery2(n) {
  return "@media screen and (min-width: " + n + ")";
};
var getValue = function getValue2(n, scale) {
  return get$1(scale, n, n);
};
var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
var createParser = function createParser2(config2) {
  var cache = {};
  var parse = function parse2(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;
    for (var key in props) {
      if (!config2[key]) continue;
      var sx = config2[key];
      var raw = props[key];
      var scale = get$1(props.theme, sx.scale, sx.defaults);
      if (typeof raw === "object") {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$1(props.theme, "breakpoints", defaults$4.breakpoints);
        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }
        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }
        continue;
      }
      assign(styles, sx(raw, scale, props));
    }
    if (shouldSort) {
      styles = sort(styles);
    }
    return styles;
  };
  parse.config = config2;
  parse.propNames = Object.keys(config2);
  parse.cache = cache;
  var keys = Object.keys(config2).filter(function(k) {
    return k !== "config";
  });
  if (keys.length > 1) {
    keys.forEach(function(key) {
      var _createParser;
      parse[key] = createParser2((_createParser = {}, _createParser[key] = config2[key], _createParser));
    });
  }
  return parse;
};
var parseResponsiveStyle = function parseResponsiveStyle2(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function(value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);
    if (!media) {
      assign(styles, style);
    } else {
      var _assign2;
      assign(styles, (_assign2 = {}, _assign2[media] = assign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};
var parseResponsiveObject = function parseResponsiveObject2(breakpoints, sx, scale, raw, _props) {
  var styles = {};
  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);
    if (!breakpoint) {
      assign(styles, style);
    } else {
      var _assign3;
      var media = createMediaQuery(breakpoint);
      assign(styles, (_assign3 = {}, _assign3[media] = assign({}, styles[media], style), _assign3));
    }
  }
  return styles;
};
var createStyleFunction = function createStyleFunction2(_ref) {
  var properties = _ref.properties, property = _ref.property, scale = _ref.scale, _ref$transform = _ref.transform, transform = _ref$transform === void 0 ? getValue : _ref$transform, defaultScale = _ref.defaultScale;
  properties = properties || [property];
  var sx = function sx2(value, scale2, _props) {
    var result = {};
    var n = transform(value, scale2, _props);
    if (n === null) return;
    properties.forEach(function(prop) {
      result[prop] = n;
    });
    return result;
  };
  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
};
var system = function system2(args) {
  if (args === void 0) {
    args = {};
  }
  var config2 = {};
  Object.keys(args).forEach(function(key) {
    var conf = args[key];
    if (conf === true) {
      config2[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }
    if (typeof conf === "function") {
      config2[key] = conf;
      return;
    }
    config2[key] = createStyleFunction(conf);
  });
  var parser = createParser(config2);
  return parser;
};
var compose = function compose2() {
  var config2 = {};
  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }
  parsers.forEach(function(parser2) {
    if (!parser2 || !parser2.config) return;
    assign(config2, parser2.config);
  });
  var parser = createParser(config2);
  return parser;
};
var isNumber$1 = function isNumber(n) {
  return typeof n === "number" && !isNaN(n);
};
var getWidth = function getWidth2(n, scale) {
  return get$1(scale, n, !isNumber$1(n) || n > 1 ? n : n * 100 + "%");
};
var config$7 = {
  width: {
    property: "width",
    scale: "sizes",
    transform: getWidth
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$7);
var config$6 = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
var color = system(config$6);
var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$5);
var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$4);
var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$3);
var config$2 = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
config$2.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
config$2.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
config$2.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
config$2.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
config$2.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
config$2.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
config$2.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
config$2.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
config$2.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
config$2.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
config$2.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
config$2.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
config$2.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
config$2.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
config$2.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
config$2.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var border = system(config$2);
var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
var background = system(config$1);
var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: defaults$1.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: defaults$1.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: defaults$1.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: defaults$1.space
  }
};
var position = system(config);
var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var isNumber2 = function isNumber3(n) {
  return typeof n === "number" && !isNaN(n);
};
var getMargin = function getMargin2(n, scale) {
  if (!isNumber2(n)) {
    return get$1(scale, n, n);
  }
  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$1(scale, absolute, absolute);
  if (!isNumber2(value)) {
    return isNegative ? "-" + value : value;
  }
  return value * (isNegative ? -1 : 1);
};
var configs = {};
configs.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: defaults.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: defaults.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);
var shadow = system({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var get2 = function get3(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function(n) {
  return n + "em";
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};
var positiveOrNegative = function positiveOrNegative2(scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get2(scale, value, value);
  }
  var absolute = Math.abs(value);
  var n = get2(scale, absolute, absolute);
  if (typeof n === "string") return "-" + n;
  return n * -1;
};
var transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(acc, curr) {
  var _extends2;
  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive2(styles) {
  return function(theme) {
    var next = {};
    var breakpoints = get2(theme, "breakpoints", defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function(n) {
      return "@media screen and (min-width: " + n + ")";
    }));
    for (var key in styles) {
      var value = typeof styles[key] === "function" ? styles[key](theme) : styles[key];
      if (value == null) continue;
      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }
      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];
        if (!media) {
          next[key] = value[i];
          continue;
        }
        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }
    return next;
  };
};
var css = function css2(args) {
  return function(props) {
    if (props === void 0) {
      props = {};
    }
    var theme = _extends({}, defaultTheme, {}, props.theme || props);
    var result = {};
    var obj = typeof args === "function" ? args(theme) : args;
    var styles = responsive(obj)(theme);
    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === "function" ? x(theme) : x;
      if (key === "variant") {
        var variant3 = css2(get2(theme, val))(theme);
        result = _extends({}, result, {}, variant3);
        continue;
      }
      if (val && typeof val === "object") {
        result[key] = css2(val)(theme);
        continue;
      }
      var prop = get2(aliases, key, key);
      var scaleName = get2(scales, prop);
      var scale = get2(theme, scaleName, get2(theme, prop, {}));
      var transform = get2(transforms, prop, get2);
      var value = transform(scale, val, val);
      if (multiples[prop]) {
        var dirs = multiples[prop];
        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }
    return result;
  };
};
var variant = function variant2(_ref) {
  var _config;
  var scale = _ref.scale, _ref$prop = _ref.prop, prop = _ref$prop === void 0 ? "variant" : _ref$prop, _ref$variants = _ref.variants, variants = _ref$variants === void 0 ? {} : _ref$variants, key = _ref.key;
  var sx;
  if (Object.keys(variants).length) {
    sx = function sx2(value, scale2, props) {
      return css(get$1(scale2, value, null))(props.theme);
    };
  } else {
    sx = function sx2(value, scale2) {
      return get$1(scale2, value, null);
    };
  }
  sx.scale = scale || key;
  sx.defaults = variants;
  var config2 = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config2);
  return parser;
};
variant({
  key: "buttons"
});
variant({
  key: "textStyles",
  prop: "textStyle"
});
variant({
  key: "colorStyles",
  prop: "colors"
});
layout.width;
layout.height;
layout.minWidth;
layout.minHeight;
layout.maxWidth;
layout.maxHeight;
layout.size;
layout.verticalAlign;
layout.display;
layout.overflow;
layout.overflowX;
layout.overflowY;
color.opacity;
typography.fontSize;
typography.fontFamily;
typography.fontWeight;
typography.lineHeight;
typography.textAlign;
typography.fontStyle;
typography.letterSpacing;
flexbox.alignItems;
flexbox.alignContent;
flexbox.justifyItems;
flexbox.justifyContent;
flexbox.flexWrap;
flexbox.flexDirection;
flexbox.flex;
flexbox.flexGrow;
flexbox.flexShrink;
flexbox.flexBasis;
flexbox.justifySelf;
flexbox.alignSelf;
flexbox.order;
grid.gridGap;
grid.gridColumnGap;
grid.gridRowGap;
grid.gridColumn;
grid.gridRow;
grid.gridAutoFlow;
grid.gridAutoColumns;
grid.gridAutoRows;
grid.gridTemplateColumns;
grid.gridTemplateRows;
grid.gridTemplateAreas;
grid.gridArea;
var borderWidth = border.borderWidth, borderStyle = border.borderStyle, borderColor = border.borderColor, borderTop = border.borderTop, borderRight = border.borderRight, borderBottom = border.borderBottom, borderLeft = border.borderLeft;
border.borderRadius;
background.backgroundImage;
background.backgroundSize;
background.backgroundPosition;
background.backgroundRepeat;
position.zIndex;
position.top;
position.right;
position.bottom;
position.left;
const svgConfig = {
  fill: {
    property: "fill",
    scale: "colors"
  },
  fillOpacity: {
    property: "fillOpacity"
  },
  stroke: {
    property: "stroke",
    scale: "colors"
  },
  strokeWidth: {
    property: "strokeWidth",
    scale: "borderWidth"
  },
  strokeOpacity: {
    property: "strokeOpacity"
  }
};
const svg = system(svgConfig);
const BREAKPOINTS = {
  mobile: {
    max: "767px"
  },
  mobileLarge: {
    min: "560px",
    max: "767px"
  },
  tablet: {
    min: "768px",
    max: "1135px"
  },
  laptop: {
    min: "1136px",
    max: "1439px"
  },
  largeDesktop: {
    min: "1440px"
  },
  desktop: {
    min: "768px"
  }
};
const pseudostatePropsArray = ["hoverStyle", "activeStyle", "focusStyle", "selectedStyle", "unselectedStyle", "invalidStyle", "disabledStyle", "selectedDisabledStyle", "visitedStyle", "checkedStyle"];
var Pseudostate = /* @__PURE__ */ ((Pseudostate2) => {
  Pseudostate2["hover"] = "hover";
  Pseudostate2["active"] = "active";
  Pseudostate2["disabled"] = "disabled";
  Pseudostate2["invalid"] = "invalid";
  Pseudostate2["selected"] = "selected";
  Pseudostate2["selectedDisabled"] = "selected-disabled";
  Pseudostate2["unselected"] = "unselected";
  Pseudostate2["visited"] = "visited";
  Pseudostate2["focus-visible"] = "focus-visible";
  Pseudostate2["focus-within"] = "focus-within";
  Pseudostate2["focus"] = "focus";
  Pseudostate2["checked"] = "checked";
  return Pseudostate2;
})(Pseudostate || {});
const insertSvgStyles = (props) => css$1`
    /* if using svg styles on a container (ex. Button), we have to specify the svg scope for the styles to apply correctly */
    & svg {
      fill: ${props.fill};
      fill-opacity: ${props.fillOpacity};
      stroke: ${props.stroke};
      stroke-width: ${props.strokeWidth};
      stroke-opacity: ${props.strokeOpacity};
    }
  `;
const insertComposeLogic = (styledSystemFns, props = {}) => {
  return css$1`
    ${compose(...styledSystemFns)({
    ...props
  })}
    ${styledSystemFns.includes(svg) && insertSvgStyles(props)}
  `;
};
const composePseudostate = (styledSystemFns, pseudostate, props) => {
  switch (pseudostate) {
    case "hover":
      return css$1`
        &:hover,
        &.hover {
          ${insertComposeLogic(styledSystemFns, props.hoverStyle)}
        }
      `;
    case "active":
      return css$1`
        &:active,
        &.active {
          ${insertComposeLogic(styledSystemFns, props.activeStyle)}
        }
      `;
    case "focus":
      return css$1`
        &:focus,
        &.focus {
          ${insertComposeLogic(styledSystemFns, props.focusStyle)}
        }
      `;
    case "focus-visible":
      return css$1`
        &:focus-visible,
        &.focus-visible {
          ${insertComposeLogic(styledSystemFns, props.focusStyle)}
        }
      `;
    case "focus-within":
      return css$1`
        &:focus-within,
        &.focus-within {
          ${insertComposeLogic(styledSystemFns, props.focusStyle)}
        }
      `;
    case "selected":
      return css$1`
        &.selected {
          ${insertComposeLogic(styledSystemFns, props.selectedStyle)}
        }
        ${props.selected && insertComposeLogic(styledSystemFns, props.selectedStyle)}
      `;
    case "unselected":
      return css$1`
        &.unselected {
          ${insertComposeLogic(styledSystemFns, props.unselectedStyle)}
        }
        ${props.unselected && insertComposeLogic(styledSystemFns, props.unselectedStyle)}
      `;
    case "disabled":
      return css$1`
        &:disabled,
        &.disabled {
          ${insertComposeLogic(styledSystemFns, props.disabledStyle)}
        }
        ${props.isDisabled && insertComposeLogic(styledSystemFns, props.disabledStyle)}
      `;
    case "selected-disabled":
      return css$1`
        &.selected-disabled {
          ${insertComposeLogic(styledSystemFns, props.selectedDisabledStyle)}
        }
        ${props.selectedDisabled && insertComposeLogic(styledSystemFns, props.selectedDisabledStyle)}
      `;
    case "visited":
      return css$1`
        &:visited,
        &.visited {
          ${insertComposeLogic(styledSystemFns, props.visitedStyle)}
        }
      `;
    case "invalid":
      return css$1`
        &:invalid,
        &.invalid {
          ${insertComposeLogic(styledSystemFns, props.invalidStyle)}
        }
      `;
    case "checked":
      return css$1`
        &:checked {
          ${insertComposeLogic(styledSystemFns, props.checkedStyle)}
        }
        ${props.checked && insertComposeLogic(styledSystemFns, props.checkedStyle)}
      `;
    default:
      return "";
  }
};
const buildMediaQueryHeading = (breakpointObject, breakpointName) => {
  const {
    min,
    max
  } = breakpointObject || {};
  if (min && max) {
    return css$1`
      /* stylelint-disable-next-line */
      (min-width: ${min}) and (max-width: ${max})
    `;
  }
  if (min) {
    return css$1`
      /* stylelint-disable-next-line */
      (min-width: ${min})
    `;
  }
  if (max) {
    return css$1`
      /* stylelint-disable-next-line */
      (max-width: ${max})
    `;
  }
  console.warn(`Could not find a valid breakpoint for ${breakpointName}. Breakpoint object received: `, JSON.stringify(breakpointObject));
  return "";
};
const composeMediaQueryStyles = (styledSystemFns) => css$1`
  ${(props) => {
  if (!props.responsive) {
    return "";
  }
  return Object.entries(props.responsive).map(([breakpointName, styleProps]) => {
    const breakpointValues = BREAKPOINTS[breakpointName] || {};
    return css$1`
          @media ${buildMediaQueryHeading(breakpointValues, breakpointName)} {
            ${compose(...styledSystemFns)(styleProps)}
          }
        `;
  });
}}
`;
const composeWrapper = (styledSystemFns, pseudostates = []) => {
  return (props = {}) => css$1`
    /* Uses compose straight out of styled-system */
    ${insertComposeLogic(styledSystemFns, props)}
    /* Iterate through all the provided pseudostates and generate a compose for each one */
    ${pseudostates.map((pseudostateName) => composePseudostate(styledSystemFns, pseudostateName, props))}
    /* Adds responsive CSS media query styles (styles specific to breakpoints) */
    ${composeMediaQueryStyles(styledSystemFns)}
  `;
};
function withKindredTheme(Component, theme = PURPLE_THEME) {
  return (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyleSheetManager, { shouldForwardProp: kindredShouldForwardProp, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Component, { ...props }) }) });
}
export {
  Pseudostate as P,
  compose as a,
  color as b,
  createContext as c,
  background as d,
  border as e,
  composeWrapper as f,
  flexbox as g,
  grid as h,
  padding as i,
  system as j,
  shadow as k,
  layout as l,
  svg as m,
  pseudostatePropsArray as n,
  borderColor as o,
  position as p,
  borderTop as q,
  borderLeft as r,
  space as s,
  typography as t,
  borderBottom as u,
  borderRight as v,
  withKindredTheme as w,
  borderWidth as x,
  borderStyle as y,
  margin as z
};
